import { call, put, take, takeLatest } from "redux-saga/effects";
import {
  deleteChecklistQuestionApi,
  getChecklistDefectsListByIDApi,
  getChecklistListApi,
  getChecklistQuestionAnswerListApi,
} from "../requests/checklistRequests";
import { toast } from "react-toastify";
import { ChecklistActions } from "../../action-types/checklistActionTypes";
import {
  deleteItemSuccess,
  setChecklistDefectsList,
  setChecklistList,
  setChecklistQuestionAnswerList,
  setChecklistpagination,
} from "../../actions/checklistAction";
import { setLoader } from "../../actions/userActions";

function* getChecklistHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(getChecklistListApi, action.payload);
    if (data.status) {
      yield put(setChecklistList(data.data));
      yield put(setChecklistpagination(data.pagination));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* getChecklistQuestionAnswerHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(
      getChecklistQuestionAnswerListApi,
      action.payload?.checklist_id
    );
    if (data.status) {
      yield put(setChecklistQuestionAnswerList(data.data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

function* deleteItemSaga(action) {
  try {
    const { itemId } = action.payload;
    yield call(deleteChecklistQuestionApi, itemId);
  } catch (error) {
    yield toast.error(error.response.data.message);
  }
}
function* getChecklistDefectListHandler(action) {
  // start loader here
  yield put(setLoader(true));
  try {
    const { data } = yield call(
      getChecklistDefectsListByIDApi,
      action.payload?.checklist_id
    );
    console.log(data, "data-->");
    if (data.status) {
      yield put(setChecklistDefectsList(data.data));
    } else {
      yield toast.error(data.message);
    }
    // handle response here and set into reducer
  } catch (error) {
    yield toast.error(error.response.data.message);
    // handle error
  } finally {
    //stop loader here
    yield put(setLoader(false));
  }
}

// accountHandler Sagas
export default function* checklistSaga() {
  yield takeLatest(ChecklistActions.GET_CHECKLIST_LIST, getChecklistHandler);
  yield takeLatest(
    ChecklistActions.GET_CHECKLIST_QUESTION_ANSWER_LIST,
    getChecklistQuestionAnswerHandler
  );
  yield takeLatest(ChecklistActions.DELETE_CHECKLIST_QUESTION, deleteItemSaga);
  yield takeLatest(
    ChecklistActions.GET_CHECKLIST_QUESTION_ANSWER_LIST,
    getChecklistQuestionAnswerHandler
  );
  yield takeLatest(
    ChecklistActions.GET_CHECKLIST_DEFECTS_LIST,
    getChecklistDefectListHandler
  );
}
